// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-pdf {
  width: 100%;
  min-height: 100vh;
  background: white;
  padding: 20px;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
}
.invoice-pdf .invoice-header,
.invoice-pdf .invoice-footer {
  width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}
.invoice-pdf .invoice-header {
  margin-bottom: 20px;
}
.invoice-pdf .invoice-footer {
  margin-top: auto;
  margin-bottom: 0;
}
.invoice-pdf .invoice-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.invoice-pdf .company-name {
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
}
.invoice-pdf .invoice-details-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 30px;
  width: 100%;
}
.invoice-pdf .invoice-details-container .invoice-info,
.invoice-pdf .invoice-details-container .client-info {
  flex: 1 1;
  max-width: 50%;
}
.invoice-pdf .invoice-details-container .invoice-info h3,
.invoice-pdf .invoice-details-container .client-info h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
  border-bottom: 2px solid #004A9A;
  padding-bottom: 5px;
  width: 100%;
}
.invoice-pdf .invoice-details-container .invoice-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 15px;
  margin-right: 0;
}
.invoice-pdf .invoice-details-container .client-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 15px;
  margin-left: 0;
  min-width: 0;
}
.invoice-pdf .invoice-details-container .client-info h3 {
  text-align: right;
}
.invoice-pdf .invoice-details-container .client-info p {
  width: 100%;
  word-wrap: break-word;
}
.invoice-pdf .invoice-info p,
.invoice-pdf .client-info p,
.invoice-pdf .bank-details p,
.invoice-pdf .terms p {
  margin: 4px 0;
  font-size: 14px;
}
.invoice-pdf .invoice-info p strong,
.invoice-pdf .client-info p strong,
.invoice-pdf .bank-details p strong,
.invoice-pdf .terms p strong {
  font-weight: bold;
}
.invoice-pdf .invoice-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background: white;
}
.invoice-pdf .invoice-table th,
.invoice-pdf .invoice-table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: left;
  vertical-align: top;
}
.invoice-pdf .invoice-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  font-size: 14px;
}
.invoice-pdf .invoice-table td {
  font-size: 13px;
}
.invoice-pdf .invoice-table th:nth-child(1),
.invoice-pdf .invoice-table td:nth-child(1) {
  width: 50%;
}
.invoice-pdf .invoice-table th:nth-child(2),
.invoice-pdf .invoice-table td:nth-child(2) {
  width: 15%;
  text-align: center;
}
.invoice-pdf .invoice-table th:nth-child(3),
.invoice-pdf .invoice-table td:nth-child(3) {
  width: 35%;
  text-align: right;
}
.invoice-pdf .breakdown-table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  background: white;
}
.invoice-pdf .breakdown-table td {
  border: 1px solid #000;
  padding: 8px;
  font-size: 13px;
  vertical-align: top;
}
.invoice-pdf .breakdown-table td:nth-child(1) {
  width: 50%;
}
.invoice-pdf .breakdown-table td:nth-child(2) {
  width: 15%;
  text-align: right;
  font-weight: normal;
}
.invoice-pdf .breakdown-table td:nth-child(3) {
  width: 35%;
  text-align: right;
  font-weight: normal;
}
.invoice-pdf .bank-details,
.invoice-pdf .terms {
  margin: 15px 0;
}
.invoice-pdf .bank-details strong,
.invoice-pdf .terms strong {
  display: block;
  margin-bottom: 5px;
  font-size: 16px;
}
.invoice-pdf .signature {
  margin-top: 20px;
  text-align: right;
}
.invoice-pdf .signature img {
  width: 150px;
  margin-top: 10px;
  height: auto;
}
.invoice-pdf .signature p {
  margin: 10px 0 0 0;
  font-size: 12px;
  font-style: italic;
}
@media print {
  .invoice-pdf {
    width: 100%;
    margin: 0;
    padding: 20px;
  }
  .invoice-pdf .invoice-header,
  .invoice-pdf .invoice-footer {
    max-width: 100%;
    page-break-inside: avoid;
  }
  .invoice-pdf .invoice-table,
  .invoice-pdf .breakdown-table {
    page-break-inside: avoid;
  }
  .invoice-pdf .bank-details,
  .invoice-pdf .terms,
  .invoice-pdf .signature {
    page-break-inside: avoid;
  }
  .invoice-pdf .invoice-details-container {
    page-break-inside: avoid;
  }
}
@media (max-width: 768px) {
  .invoice-pdf .invoice-details-container {
    flex-direction: column;
    gap: 20px;
  }
  .invoice-pdf .invoice-details-container .invoice-info {
    padding-right: 0;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 15px;
  }
  .invoice-pdf .invoice-details-container .client-info {
    padding-left: 0;
    padding-top: 15px;
    text-align: left;
  }
  .invoice-pdf .invoice-details-container .client-info h3,
  .invoice-pdf .invoice-details-container .client-info p {
    text-align: left;
  }
}
.invoice-pdf * {
  box-sizing: border-box;
}
.invoice-pdf p,
.invoice-pdf div,
.invoice-pdf section {
  orphans: 2;
  widows: 2;
}
.invoice-pdf .invoice-info,
.invoice-pdf .client-info,
.invoice-pdf .bank-details,
.invoice-pdf .terms,
.invoice-pdf .signature {
  page-break-inside: avoid;
}

.req-pad {
  padding: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/InvoicePDFTemplate/InvoicePDFTemplate.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACF;AAEE;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,gBAAA;EACA,gBAAA;AAFJ;AAME;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAJJ;AAQE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AANJ;AAUE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AARJ;AAUI;;EAEE,SAAA;EACA,cAAA;AARN;AAUM;;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;AAPR;AAWI;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AATN;AAYI;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAVN;AAYM;EACE,iBAAA;AAVR;AAaM;EACE,WAAA;EACA,qBAAA;AAXR;AAiBE;;;;EAIE,aAAA;EACA,eAAA;AAfJ;AAiBI;;;;EACE,iBAAA;AAZN;AAgBE;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AAdJ;AAgBI;;EAEE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAdN;AAiBI;EACE,yBAAA;EACA,iBAAA;EACA,eAAA;AAfN;AAkBI;EACE,eAAA;AAhBN;AAmBI;;EAEE,UAAA;AAjBN;AAoBI;;EAEE,UAAA;EACA,kBAAA;AAlBN;AAqBI;;EAEE,UAAA;EACA,iBAAA;AAnBN;AAuBE;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AArBJ;AAuBI;EACE,sBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AArBN;AAyBI;EAEE,UAAA;AAxBN;AA2BI;EAEE,UAAA;EACA,iBAAA;EACA,mBAAA;AA1BN;AA6BI;EAEE,UAAA;EACA,iBAAA;EACA,mBAAA;AA5BN;AAgCE;;EAEE,cAAA;AA9BJ;AAgCI;;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AA7BN;AAkCE;EACE,gBAAA;EACA,iBAAA;AAhCJ;AAkCI;EACE,YAAA;EACA,gBAAA;EACA,YAAA;AAhCN;AAmCI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AAjCN;AAqCE;EA5NF;IA6NI,WAAA;IACA,SAAA;IACA,aAAA;EAlCF;EAoCE;;IAEE,eAAA;IACA,wBAAA;EAlCJ;EAqCE;;IAEE,wBAAA;EAnCJ;EAsCE;;;IAGE,wBAAA;EApCJ;EAuCE;IACE,wBAAA;EArCJ;AACF;AAyCE;EACE;IACE,sBAAA;IACA,SAAA;EAvCJ;EAyCI;IACE,gBAAA;IACA,gCAAA;IACA,oBAAA;EAvCN;EA0CI;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EAxCN;EA0CM;;IAEE,gBAAA;EAxCR;AACF;AA8CE;EACE,sBAAA;AA5CJ;AA+CE;;;EAGE,UAAA;EACA,SAAA;AA7CJ;AAiDE;;;;;EAKE,wBAAA;AA/CJ;;AAmDA;EACE,eAAA;AAhDF","sourcesContent":[".invoice-pdf {\n  width: 100%;\n  min-height: 100vh;\n  background: white;\n  padding: 20px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #333;\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  // Header and Footer images\n  .invoice-header,\n  .invoice-footer {\n    width: 100%;\n    height: auto;\n    max-height: 150px;\n    object-fit: contain;\n    display: block;\n    flex-shrink: 0; // Prevent shrinking\n  }\n\n  .invoice-header {\n    margin-bottom: 20px;\n  }\n\n  .invoice-footer {\n    margin-top: auto; // Push to bottom\n    margin-bottom: 0;\n  }\n\n  // Content wrapper to ensure proper spacing\n  .invoice-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-height: 0; // Allow shrinking if needed\n  }\n\n  // Company name style\n  .company-name {\n    font-size: 28px;\n    text-align: center;\n    margin-bottom: 20px;\n    font-weight: bold;\n  }\n\n  // Two-column layout for invoice details and client info\n  .invoice-details-container {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    gap: 30px;\n    width: 100%;\n\n    .invoice-info,\n    .client-info {\n      flex: 1;\n      max-width: 50%;\n\n      h3 {\n        font-size: 16px;\n        font-weight: bold;\n        margin-bottom: 10px;\n        color: #333;\n        border-bottom: 2px solid #004A9A;\n        padding-bottom: 5px;\n        width: 100%;\n      }\n    }\n\n    .invoice-info {\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n      padding-right: 15px;\n      margin-right: 0;\n    }\n\n    .client-info {\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start; // CHANGE FROM flex-end to flex-start\n      padding-left: 15px;\n      margin-left: 0;\n      min-width: 0;\n\n      h3 {\n        text-align: right;\n      }\n\n      p {\n        width: 100%;\n        word-wrap: break-word;\n      }\n    }\n  }\n\n  // Paragraph styles\n  .invoice-info p,\n  .client-info p,\n  .bank-details p,\n  .terms p {\n    margin: 4px 0;\n    font-size: 14px;\n\n    strong {\n      font-weight: bold;\n    }\n  }\n\n  .invoice-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 20px 0;\n    background: white;\n\n    th,\n    td {\n      border: 1px solid #000;\n      padding: 8px;\n      text-align: left;\n      vertical-align: top;\n    }\n\n    th {\n      background-color: #f5f5f5;\n      font-weight: bold;\n      font-size: 14px;\n    }\n\n    td {\n      font-size: 13px;\n    }\n\n    th:nth-child(1),\n    td:nth-child(1) {\n      width: 50%;\n    }\n\n    th:nth-child(2),\n    td:nth-child(2) {\n      width: 15%;\n      text-align: center;\n    }\n\n    th:nth-child(3),\n    td:nth-child(3) {\n      width: 35%;\n      text-align: right;\n    }\n  }\n\n  .breakdown-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 10px 0;\n    background: white;\n\n    td {\n      border: 1px solid #000;\n      padding: 8px;\n      font-size: 13px;\n      vertical-align: top;\n    }\n\n    // Column width matching main table\n    td:nth-child(1) {\n      // Empty column to match Description\n      width: 50%;\n    }\n\n    td:nth-child(2) {\n      // Label column\n      width: 15%;\n      text-align: right;\n      font-weight: normal;\n    }\n\n    td:nth-child(3) {\n      // Amount column\n      width: 35%;\n      text-align: right;\n      font-weight: normal;\n    }\n  }\n\n  .bank-details,\n  .terms {\n    margin: 15px 0;\n\n    strong {\n      display: block;\n      margin-bottom: 5px;\n      font-size: 16px;\n    }\n  }\n\n  // Signature style\n  .signature {\n    margin-top: 20px;\n    text-align: right;\n\n    img {\n      width: 150px;\n      margin-top: 10px;\n      height: auto;\n    }\n\n    p {\n      margin: 10px 0 0 0;\n      font-size: 12px;\n      font-style: italic;\n    }\n  }\n\n  @media print {\n    width: 100%;\n    margin: 0;\n    padding: 20px;\n\n    .invoice-header,\n    .invoice-footer {\n      max-width: 100%;\n      page-break-inside: avoid;\n    }\n\n    .invoice-table,\n    .breakdown-table {\n      page-break-inside: avoid;\n    }\n\n    .bank-details,\n    .terms,\n    .signature {\n      page-break-inside: avoid;\n    }\n\n    .invoice-details-container {\n      page-break-inside: avoid;\n    }\n  }\n\n  // Responsive design for smaller screens\n  @media (max-width: 768px) {\n    .invoice-details-container {\n      flex-direction: column;\n      gap: 20px;\n\n      .invoice-info {\n        padding-right: 0;\n        border-bottom: 1px solid #e0e0e0;\n        padding-bottom: 15px;\n      }\n\n      .client-info {\n        padding-left: 0;\n        padding-top: 15px;\n        text-align: left; // Reset alignment on mobile\n\n        h3,\n        p {\n          text-align: left;\n        }\n      }\n    }\n  }\n\n  // Ensure proper spacing and avoid orphans\n  * {\n    box-sizing: border-box;\n  }\n\n  p,\n  div,\n  section {\n    orphans: 2;\n    widows: 2;\n  }\n\n  // Force content to stay together when possible\n  .invoice-info,\n  .client-info,\n  .bank-details,\n  .terms,\n  .signature {\n    page-break-inside: avoid;\n  }\n}\n\n.req-pad {\n  padding: 0.8rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
